import React, { useEffect, useState } from "react";
import Logo from "../assets/Logo2.png";
import InfoIcon from "@mui/icons-material/Info";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import CommentRounded from "@mui/icons-material/CommentRounded";
import GetAppIcon from "@mui/icons-material/GetApp";
import MenuIcon from "@mui/icons-material/Menu";
import { HiOutlineBars3 } from "react-icons/hi2";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ColourPalette, getAdjustingFontSizeByHeightWidth, getIsMobile, getIsTablet, getScreenSize } from "../globalConstants";
import AppLogo from "../assets/appLogo.png";
import { GetTheApp, downloadAppButton } from "./homeHelper";
import { getMobileDownloadButtonValues } from "../globalConstants";
import { sendLog } from "../App";
import { DownloadButtonsDesktop } from "./DownloadButtonsDesktop";
import { DownloadButtonsMobile } from "./DownloadButtonsMobile";
import { navbarState } from "./navbarState";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);

  const mobileNavBarButton = () => {
    const vals = getMobileDownloadButtonValues();
    if (vals != null) {
      return downloadAppButton(vals.source, vals.link);
    } else {
      return null;
    }
  };
  const [hideForHover, setHideForHover] = useState(false);

  useEffect(() => {
    const unsub = navbarState.subscribe(setHideForHover);
    return unsub;
  }, []);
  const menuOptions = getIsTablet() || getIsMobile() ? [
    { text: "Subscriptions", icon: <SubscriptionsIcon /> },
    { text: "About", icon: <InfoIcon /> },
    // { text: "Reviews", icon: <CommentRounded /> },
  ] : [
    { text: "Get the App", icon: <GetAppIcon /> },
    { text: "Subscriptions", icon: <SubscriptionsIcon /> },
    { text: "About", icon: <InfoIcon /> },
    // { text: "Reviews", icon: <CommentRounded /> },
  ];
  const [hoverDict, setHoverDict] = useState({
    "Get the App": false,
    About: false,
    Subscriptions: false,
    Testimonials: false,
  });


  const handleClick = (menuOption) => {
    var anchor;
    switch (menuOption) {
      case "Get the App":
        sendLog("Navbar! Clicked Get the App")
        anchor = document.querySelector("#top-of-page");
        anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        break;
      case "About":
        sendLog("Navbar! Clicked About")
        anchor = document.querySelector("#about-section");
        anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        break;
      case "Subscriptions":
        sendLog("Navbar! Clicked Subscriptions")
        anchor = document.querySelector("#subscriptions-page-wrapper");
        anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        break;
      case "Reviews":
        sendLog("Navbar! Clicked Reviews")
        anchor = document.querySelector("#review-section-wrapper");
        anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        break;
      default:
        break;
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(false);

  const primaryButtonStartHover = (key) => {
    let temp = { ...hoverDict };
    for (const key1 in temp) {
      temp[key1] = key1 === key;
    }

    !isCollapsed && setHoverDict(temp);
  };

  const primaryButtonEndHover = (key) => {
    let temp = { ...hoverDict };
    temp[key] = false;
    setHoverDict(temp);
  };

  const styles: { [key: string]: React.CSSProperties } = {

    buttonIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "0.5rem",
    },
    navbarMenuContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: 0.1,
    },
    primaryButton: {
      padding: "0.9rem 1.75rem",
      backgroundColor: "transparent",
      outline: "none",
      border: "none",
      borderRadius: "5rem",
      cursor: "pointer",
      fontWeight: 600,
      transition: "0.2s",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-evenly",
      alignItems: "center",
    },
    getTheApp: {
      maxHeight: "100%",
      maxWidth: "100%",
    },
  };


  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // Detect if user is scrolling down or up
      if (scrollTop > lastScrollTop && scrollTop > 50) {
        // Scrolling down
        setIsCollapsed(true);
      } else if (scrollTop < lastScrollTop) {
        // Scrolling up
        setIsCollapsed(false);
      }

      // Set the new last scroll position
      setLastScrollTop(scrollTop);
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollTop]); // Depend on lastScrollTop to track previous scroll position

  return (
    <div style={{
      position: "fixed", opacity: hideForHover ? 0 : 1,
      height: isCollapsed ? "0vh" : (getIsMobile() ? "7vh" : "10vh"), // Collapse height,
      minHeight: isCollapsed ? 0 : "40px",
      transition: 'height 0.3s ease',        // Smooth transition
      top: 0,
      backgroundColor: ColourPalette.lightGrey.dark,
      boxShadow: '0px 4px 6px rgba(49,68,3,0.4)',
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      justifyContent: "stretch",
      // backgroundColor: "white",
      width: "100vw",
      zIndex: 100,
      paddingLeft: getIsMobile() ? "2%" : "5%",
      paddingRight: getIsMobile() ? "2%" : "5%",
    }}>
      <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: getIsMobile() ? "center" : "flex-start",
        flex: 1, position: "relative", minWidth: 0,
      }}>
        <img
          className="logo-image"
          style={{
            objectFit: "contain",
            padding: "2%",
            minHeight: "40px", height: "100%", maxWidth: isCollapsed ? "0vh" : (getIsMobile() ? "7vh" : "10vh"),
            minWidth: isCollapsed ? 0 : "40px",
          }}
          src={AppLogo}
          alt=""
        />
        <div style={{ flexDirection: "column", minWidth: 0 }}>
          <h2 style={{
            fontFamily: "Regular", whiteSpace: 'nowrap',
            transition: 'font-size 0.3s ease',
            fontSize: isCollapsed ? 0 : getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.09,
              getScreenSize().width * 0.13,
              "Parallel Poker".length, 40), justifyContent: "center", textAlign: "center"
          }}>Parallel Poker</h2>
          {getIsMobile() || getIsTablet() ? null : <h2 style={{
            fontFamily: "Regular", whiteSpace: 'nowrap',
            transition: 'font-size 0.3s ease',
            fontSize: isCollapsed ? 0 : getAdjustingFontSizeByHeightWidth(getScreenSize().height * (getIsMobile() ? 0.02 : 0.02),
              getScreenSize().width * 0.13,
              "Poker for Strategic Minds".length, 40), justifyContent: "center", textAlign: "center"
          }}>Poker for Strategic Minds</h2>}
        </div>
      </div>
      {getIsMobile() || getIsTablet() ? (
        // Render mobile menu icon\
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            flex: getIsMobile() || getIsTablet() ? 1 : 3,
            marginRight: getIsMobile() ? 0 : "3rem",
            textDecoration: "none",
            color: "black",
            fontWeight: 600,
            padding: "0%"
          }}
        >
          {/* {getIsTablet() && mobileNavBarButton()}
          <div
            className="navbar-menu-container"
            style={{ ...styles.navbarMenuContainer }}
          >
            <MenuIcon style={{
              transition: 'font-size 0.3s ease',
              fontSize: isCollapsed ? 0 : (getIsMobile() ? 30 : 60)
            }} onClick={() => setOpenMenu(true)} />
          </div> */}
          {!isCollapsed && <div style={{ height: "100%", width: "100%", justifyContent: "center", alignItems: "center" }}>
            <DownloadButtonsMobile placement="navbar"
              shadowOn={false}
              style={{
                height: "85%", position: "absolute", top: "7.5%", right: "5%", width: getScreenSize().height * 0.2,
                borderRadius: "5px", justifyContent: "center", alignItems: "center"
              }}
            />
          </div>}
        </div>
      ) : (
        // Render links on larger screens
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: isCollapsed ? "0vh" : "10vh", // Collapse height
            transition: 'height 0.3s ease',        // Smooth transition
            justifyContent: "flex-end",
            flex: getIsMobile() || getIsTablet() ? 1 : 3,
            marginRight: getIsMobile() ? "1rem" : "3rem",
            textDecoration: "none",
            color: "black",
            fontWeight: 600,
          }}
        >
          {/* {menuOptions.map((item) => {
            const itemStyle = {
              ...styles.primaryButton, transition: 'font-size 0.3s ease',
              fontSize: isCollapsed ? 0 : "1.1rem"
            };
            if (hoverDict[item.text]) {
              itemStyle["backgroundColor"] = ColourPalette.brightGreen.main;
            }
            return (
              <button
                key={item.text}
                className="primary-button"
                style={itemStyle}
                onClick={() => handleClick(item.text)}
                onMouseEnter={() => {
                  primaryButtonStartHover(item.text);
                }}
                onMouseLeave={() => {
                  primaryButtonEndHover(item.text);
                }}
              >
                <span style={{
                  ...styles.buttonIcon, transition: 'font-size 0.3s ease',
                  fontSize: isCollapsed ? 0 : "1.1rem"
                }}>
                  {isCollapsed ? null : item.icon}
                </span>
                {item.text}
              </button>
            );
          })} */}
          {!isCollapsed &&
            <div style={{ height: "75%", width: 500, justifyContent: "center", alignItems: "center" }}>
              <DownloadButtonsDesktop placement="navbar" height={"100%"} width={250} />
            </div>
          }
          {/* <GetTheApp style={{ maxHeight: "100%" }} /> */}
        </div>
      )
      }
      <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="left">
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => setOpenMenu(false)}
          onKeyDown={() => setOpenMenu(false)}
        >
          <List>
            {menuOptions.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton onClick={() => handleClick(item.text)}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </div >
  );
};

export default Navbar;
